export default {
    created: "Contul WhatsApp a fost creat cu succes.",
    updated: "Contul WhatsApp a fost actualizat cu succes.",
    deleted: "Contul WhatsApp a fost sters cu succes.",
    restored: "Contul WhatsApp a fost restaurat cu succes.",
}
